// import "babel-polyfill";
import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

import userStore from "./UserStore";

export default new Vuex.Store({
    strict: process.env.NODE_ENV !== "production",
    modules: {
        userStore: userStore,
    },
});
